import axios from "axios";
import {create} from "zustand";

export const useMultipleEditionStore = create((set, get) => ({
    multipleEditionData: [],
    rules: [],
    loadingRules: false,

    /** ATTRIBUTES_PREFILLED_DISABLED
     * UPC (attr 683)
     * Nombre del departamento (attr 44005)
     * Departamento (attr 6996)
     * Nombre de la clase (attr 6996)
     * Clase (attr 44006)
     * Nombre de la subclase
     * Subclase (attr 44008)
     * En venta (attr 6995)
     * Solicitable (attr 44011)
     * Inventario (attr 44013)
     * Mercancía (attr 44010)
     * NIU (attr 44064)
     * Elegible (attr 44086)
     * CAMBIO DE PRECIO MANUAL (attr 6496)
     * GARANTIA EXT PRODUCTO ELEGIBLE (attr 6532)
     */

    attributesDisabled: [683, 44005, 6996, 44007, 44006, 44009, 44008, 6995, 44011, 44013, 44010, 44064, 44086, 6496, 6532, 44024, 6999],

    fetchRules: async () => {
        const { rules, loadingRules } = get();
        if (rules.length > 0 || loadingRules) return;

        set({ loadingRules: true });
        try {
            const res = await axios.get(process.env.REACT_APP_DEPENDENCY_RULES_ENDPOINT, {
                headers: { Authorization: sessionStorage.getItem('jwt') },
            });
            const body = typeof res.data.body === 'string' ? JSON.parse(res.data.body) : res.data.body;
            set({ rules: body.data, loadingRules: false });
        } catch (err) {
            console.error('Error fetching dependency rules:', err);
            set({ loadingRules: false });
        }
    },

    setRules: (rules) => set({ rules }),

    setMultipleEditionData: (data) => set({ multipleEditionData: data }),

    setMultipleDataObjValue: (articleId, attributeID, value) => {
        const newData = [...get().multipleEditionData];
        const index = newData.findIndex((item) => item.articleId === articleId);
        if (index !== -1) {
            const indexAttribute = newData[index].articleData.findIndex((item) => item.id_attribute === attributeID);
            if (indexAttribute !== -1) {
                newData[index].articleData[indexAttribute].value = value;
                set({ multipleEditionData: newData });
            }
        }
    },

    setMultipleDataObjAproval: (articleId, attributeID, isApproved, comment) => {
        const newData = [...get().multipleEditionData];
        const index = newData.findIndex((item) => item.articleId === articleId);
        if (index !== -1) {
            const indexAttribute = newData[index].articleData.findIndex((item) => item.id_attribute === attributeID);
            if (indexAttribute !== -1) {
                newData[index].articleData[indexAttribute].isApproved = isApproved;
                newData[index].articleData[indexAttribute].comment = comment;
                set({ multipleEditionData: newData });
            }
        }
    },

    getSingleAttributeObj: (articleId, attributeID) => {
        const newData = [...get().multipleEditionData];
        const index = newData.findIndex((item) => item.articleId === articleId);
        if (index !== -1) {
            const indexAttribute = newData[index].articleData.findIndex((item) => item.id_attribute === attributeID);
            return newData[index].articleData[indexAttribute];
        }
    }
}));